import { useState } from 'react';
import { getHelpRouteContext } from 'src/utils/knownRoutes';
import HelpCenterPage from './HelpCenterPage';
import HelpCenterTopicDrawer from './HelpCenterTopicPage';

const HelpCenterDrawer = ({
  isOpen,
  setIsOpen,
  isLoggedIn
}: {
  isOpen: boolean;
  setIsOpen: (arg1: boolean) => void;
  isLoggedIn: boolean;
}) => {
  const knownRoute = getHelpRouteContext(window.location.pathname);
  const [showTopic, setShowTopic] = useState(knownRoute.matched);

  if (showTopic) {
    return (
      <HelpCenterTopicDrawer
        isOpen={isOpen}
        pageName={{
          pageName: knownRoute.pageName ?? '',
          title: knownRoute.pageTitle ?? ''
        }}
        topicId={knownRoute.topicName ?? ''}
        setIsOpen={setIsOpen}
        onHomeClick={() => setShowTopic(false)}
        isLoggedIn={isLoggedIn}
      />
    );
  }

  return (
    <HelpCenterPage
      isOpen={isOpen}
      setIsOpen={setIsOpen}
      isLoggedIn={isLoggedIn}
    />
  );
};

export default HelpCenterDrawer;
